import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import { useState, useEffect } from 'react';

// Optional: Fix default marker icon (Leaflet issue)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});


const LocationPicker = ({ latitude, longitude, setLatitude, setLongitude, fetchAddressFromCoordinates }) => {
    

  const [position, setPosition] = useState([latitude, longitude]);

    

  
    useEffect(() => {
      if (latitude && longitude) {
        setPosition([latitude, longitude]);
      }
    }, [latitude, longitude]);
  
    if (!latitude || !longitude) {
      return <div>Fetching location...</div>; // Show loader or fallback UI
    }
  
    const LocationMarker = () => {
      useMapEvents({
        click(e) {
          const { lat, lng } = e.latlng;
          setPosition([lat, lng]);
          setLatitude(lat);
          setLongitude(lng);
          fetchAddressFromCoordinates(lat, lng);
        }
      });
  
      return <Marker position={position} draggable={true} eventHandlers={{
        dragend: (e) => {
          const marker = e.target;
          const newPos = marker.getLatLng();
          setPosition([newPos.lat, newPos.lng]);
          setLatitude(newPos.lat);
          setLongitude(newPos.lng);
          fetchAddressFromCoordinates(newPos.lat, newPos.lng);
        }
      }} />;
    };
  
    return (
      <MapContainer center={position} zoom={16} style={{ height: "300px", width: "100%" }}>
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <LocationMarker />
      </MapContainer>
    );
  };
  

export default LocationPicker;
